import Breadcrumb from '@components/breadcrumb/Breadcrumb';
import DataCheck from 'lib/src/components/common/DataCheck';
import Title from 'lib/src/components/typography/Title';
import { isEmpty } from 'lib/src/utils/generic';
import { useParams } from 'react-router';
import { AssessmentChallenge } from '../../../../src/types/shared/Assessments';
import { submissionsBreadcrumbs } from '../../../constants/breadcrumbItems';
import useFetchAssessmentChallenge from '../_hooks/useFetchAssessmentChallenge';
import SubmissionsTable from './SubmissionsTable';

interface ParamsType {
    id: string;
}

const Submissions = () => {
    const { id } = useParams<ParamsType>();

    const { assessmentChallenge, isFetching, fetchError } = useFetchAssessmentChallenge(
        parseInt(id),
    );

    return (
        <DataCheck
            dataExists={!isEmpty(assessmentChallenge)}
            isFetching={isFetching}
            error={fetchError}
        >
            <Breadcrumb items={submissionsBreadcrumbs} title={assessmentChallenge?.name} />
            <Title>Submissions For Assessment</Title>
            <SubmissionsTable assessmentChallenge={assessmentChallenge as AssessmentChallenge} />
        </DataCheck>
    );
};

export default Submissions;
